import React, {useEffect} from 'react';
import {useShallow} from 'zustand/react/shallow';
import {useStudentDashboard} from '../StudentDashboard.store';
import {Button, Dialogue, Modal, Text} from '@albert-io/atomic';

const InvalidEmailModal = () => {
  const {setStudentHasInvalidEmail} = useStudentDashboard(
    useShallow((state) => ({
      setStudentHasInvalidEmail: state.setStudentHasInvalidEmail
    }))
  );

  useEffect(() => {
    return () => {
      setStudentHasInvalidEmail(false);
    };
  }, [setStudentHasInvalidEmail]);

  return (
    <Modal
      ariaLabel="You don't have permission to join this classroom"
      handleClose={() => {
        setStudentHasInvalidEmail(false);
      }}
    >
      {({CloseButtonWrapper, modalContentStyle}) => (
        <Dialogue
          className={modalContentStyle}
          inModal
          hideCloseBtn
          title="You don't have permission to join this classroom"
        >
          <Dialogue.Body className='text-center'>
            <Text as='p'>Please speak with your teacher if this problem persists.</Text>
            <Text as='p'>This can happen for a few reasons:</Text>
            <Text as='div' className='text-left'>
              <ul>
                <li className='mb-x1'>
                  You signed up using an email address other than your school-issued email
                </li>
                <li className='mb-x1'>You logged into Albert using an old or incorrect username</li>
                <li className='mb-x1'>
                  You logged into Albert using an incorrect Google or Clever account
                </li>
              </ul>
            </Text>
          </Dialogue.Body>
          <div className='mt-x5 flex w-full'>
            <CloseButtonWrapper className='w-full'>
              <Button className='w-full' onClick={() => setStudentHasInvalidEmail(false)}>
                OK
              </Button>
            </CloseButtonWrapper>
          </div>
        </Dialogue>
      )}
    </Modal>
  );
};

export default InvalidEmailModal;
